import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-duration',
    templateUrl: './add-duration.component.html',
    styleUrls: ['./add-duration.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddDurationComponent implements OnInit {

	@Input() task: any;
	@Input() project: any;
	@Input() chapter: any;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'task_id': null,
		'duration': null,
		'apply': false,
		'episode': null
	}
	title: string = 'days';

	submitForm() {
		this.loading = true;
		this._tS.changeDurationTask(this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		);
	} ''

	close() {
		this.closeView.emit()
	}

	fillForm() {
		this.formData.task_id = this.task.id;
		this.formData.duration = this.chapter?.item_duration;
		this.formData.apply = this.chapter.apply_duration ? true : false;
		this.formData.episode = this.chapter.text;
		if (this.task.task_duration_type_id == 2) {
			this.title = 'weeks';
			this.formData.duration = this.formData.duration / 7;
		}
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
		if (this.chapter) {
			this.fillForm();
		}
	}

}
